<template>
  <div v-bind:style="{ height: height + 'px'}">
    <div class="content_header">
      <v-toolbar flat color="white mx-2">
        <v-toolbar-title>エンジニア技術管理</v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-spacer></v-spacer>

        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
          id="data_search"
          class="mx-4 pa-4"
          placeholder="検索"
          clearable
        ></v-text-field>

        <!-- 画像の拡大表示ダイアログ -->
        <v-dialog v-model="imgDialog" max-width="1200px">
          <v-card>
            <v-card-title>
              <v-btn color="primary" dark @click="closeScaleDialog">Close</v-btn>
            </v-card-title>
            <img height="80%" v-if="uploadImageUrl_scallview" :src="uploadImageUrl_scallview" />
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog" max-width="900px" class="ma-0">
          <template v-slot:activator="{ on }">
            <v-btn color="primary" dark class="mb-2" @click="newItem()" v-on="on">新規追加</v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">作業を登録</span>

              <v-divider class="mx-2" inset vertical></v-divider>
              <v-spacer></v-spacer>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                <v-btn color="primary" dark @click="save">Save</v-btn>
              </v-card-actions>
            </v-card-title>

            <v-card-text>
              <v-container class="pa-4">
                <v-form ref="form_check">
                  <v-row class="pa-0">
                    <!-- 名称設定 -->
                    <v-col cols="12" sm="10" md="10" class="pa-0">
                      <v-text-field
                        v-model="editedItem.category"
                        label="カテゴリ"
                        :rules="[required]"
                        counter="200"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="10" md="10" class="pa-0">
                      <v-text-field
                        v-model="editedItem.title"
                        label="タイトル"
                        :rules="[required]"
                        counter="250"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="12" md="12" class="pa-0">
                      <v-textarea
                        row="2"
                        class="custom_textarea"
                        auto-grow
                        outlined
                        v-model="editedItem.memo"
                        label="概要"
                        counter="1000"
                      ></v-textarea>
                    </v-col>

                    <v-col cols="12" sm="12" md="12" class="pa-0">
                      <v-textarea
                        row="5"
                        class="custom_textarea"
                        auto-grow
                        outlined
                        v-model="editedItem.source"
                        label="ソース"
                        counter="1000"
                      ></v-textarea>
                    </v-col>

                    <!-- 画像のアップロード -->

                    <v-col cols="12" sm="12" md="12" class="pa-0">
                      <div class="img_preview" @click="scaleImg(uploadImageUrl1)">
                        <img v-if="uploadImageUrl1" :src="uploadImageUrl1" />
                      </div>

                      <div class="img_preview" @click="scaleImg(uploadImageUrl2)">
                        <img v-if="uploadImageUrl2" :src="uploadImageUrl2" />
                      </div>
                    </v-col>
                    <v-col cols="2" sm="2" md="2" class="pa-0">
                      <v-btn color="error mt-3" outlined @click="deleteImg">画像全削除</v-btn>
                    </v-col>
                    <v-col cols="10" sm="10" md="10" class="pa-0">
                      <v-form ref="form">
                        <v-file-input
                          v-model="input_image"
                          accept="image/*"
                          multiple
                          show-size
                          label="画像(2ファイルまで)"
                          prepend-icon="mdi-image"
                          @change="onImagePicked"
                        ></v-file-input>
                      </v-form>
                    </v-col>
                  </v-row>
                </v-form>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </div>

    <v-card class="ma-6"></v-card>
    <v-card class="ma-6">
      <v-data-table
        :headers="headers"
        :items="list"
        :search="search"
        :items-per-page="25"
        sort-by="id"
        sort-desc
        :footer-props="{itemsPerPageOptions: [25, 50, 100, -1]}"
      >
        <template v-slot:item.category="{ item }">
          <div @click="editItem(item)" text>{{item.category}}</div>
        </template>

        <template v-slot:item.title="{ item }">
          <div @click="editItem(item)" text>{{item.title}}</div>
        </template>

        <template v-slot:item.memo="{ item }">
          <div @click="editItem(item)" text>-</div>
        </template>

        <template v-slot:item.source="{ item }">
          <div @click="editItem(item)" text style="text-transform: none">{{item.source}}</div>
        </template>

        <template v-slot:item.edit="{ item }">
          <v-container class="pa-0">
            <v-form>
              <v-row>
                <v-col cols="4" sm="4" md="4">
                  <v-icon small color="primary" @click="deleteItem(item)">fas fa-trash</v-icon>
                </v-col>

                <v-col cols="4" sm="4" md="4">
                  <v-icon small color="primary" @click="editItem(item)">fas fa-edit</v-icon>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>



<script>
// Ajax通信ライブラリ
import axios from "axios";

export default {
  data() {
    return {
      //検索用パラメータ
      search: "",
      height: 0,
      dialog: false,
      headers: [
        { text: "id", value: "id", width: "44px", align: "center" },
        { text: "category", value: "category", width: "100px" },
        { text: "title", value: "title", width: "300px" },
        { text: "", value: "memo", width: "20px", fixed: true },
        { text: "source", value: "source", width: "114px",align: "left", fixed: true },
        { text: "編集", value: "edit", width: "60px" }
      ],
      list: [],
      editedIndex: -1,
      editedItem: {
        id: "",
        category: "",
        title: "",
        source: "",
        memo: "",
        img_count: 0,
        imageData1: "",
        imageData2: ""
      },
      //画像系
      input_video: null,
      input_image: null,
      uploadImageUrl_scallview: "",
      uploadImageUrl1: "",
      uploadImageUrl2: "",

      //画像拡大用
      imgDialog: false,

      // 入力規則
      required: value => !!value || "必ず入力してください" // 入力必須の制約
    };
  },

  computed: {},

  methods: {
    deleteImg() {
      this.uploadImageUrl1 = "";
      this.uploadImageUrl2 = "";
      this.editedItem.imageData1 = "";
      this.editedItem.imageData2 = "";
      this.editedItem.img_count = 0;
    },

    //画像の読み込み
    onImagePicked(file) {
      if (this.input_image == null || this.input_image == "") {
        this.uploadImageUrl1 = "";
        this.uploadImageUrl2 = "";
        this.editedItem.imageData1 = "";
        this.editedItem.imageData2 = "";
        this.editedItem.img_count = 0;
        return false;
      }

      var img_size = file.length;
      if (img_size > 2) {
        alert("画像のアップロードは2ファイルまで");
        return;
      }

      if (file == null || file.length == 0) {
        return false;
      }

      this.uploadImageUrl1 = "";
      this.uploadImageUrl2 = "";

      for (var i = 1; i <= img_size; ++i) {
        var tmp_file = file[i - 1];
        if (tmp_file !== undefined && tmp_file !== null) {
          if (tmp_file.name.lastIndexOf(".") <= 0) {
            return;
          }
          const fr = new FileReader();
          fr.readAsDataURL(tmp_file);
          fr.addEventListener("load", () => {
            if (this.uploadImageUrl1 == "") {
              this.uploadImageUrl1 = fr.result;
              this.editedItem.imageData1 = fr.result;
              this.editedItem.img_count = 1;
            } else {
              this.uploadImageUrl2 = fr.result;
              this.editedItem.imageData2 = fr.result;
              this.editedItem.img_count = 2;
            }
          });
        }
      }
    },

    editItem(item) {
      this.editedIndex = this.list.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;

      //画像のロード

      if (item.img_count == 1) {
        this.uploadImageUrl1 =
          "https://tool-test.matomeroyal.com/wp-content/themes/tool/enginner_img/" +
          item.id +
          "_1";
        this.uploadImageUrl2 = "";
      } else if (item.img_count == 2) {
        this.uploadImageUrl1 =
          "https://tool-test.matomeroyal.com/wp-content/themes/tool/enginner_img/" +
          item.id +
          "_1";

        this.uploadImageUrl2 =
          "https://tool-test.matomeroyal.com/wp-content/themes/tool/enginner_img/" +
          item.id +
          "_2";
      } else {
        this.uploadImageUrl1 = "";
        this.uploadImageUrl2 = "";
      }

      // this.loadImg(item);
    },

    //画像の拡大表示
    scaleImg(img_data) {
      if (img_data != "") {
        this.uploadImageUrl_scallview = img_data;
        this.imgDialog = true;
      }
    },
    closeScaleDialog() {
      this.imgDialog = false;
    },

    save() {
      // console.log(this.editedItem)
      var self = this;
      axios
        .post(process.env.VUE_APP_ENGINEER_WORK_SAVE, {
          data: this.editedItem
        })
        .then(function(response) {
          console.log(response);
          //新規追加
          if (response.data["status"] == 1) {
            self.editedItem["id"] = response.data["last_id"];
            self.list.push(self.editedItem);
            //更新
          } else if (response.data["status"] == 2) {
            Object.assign(self.list[self.editedIndex], self.editedItem);
          } else {
            alert("更新失敗！！");
          }
          self.close();
        });
    },

    //削除
    deleteItem(item) {
      var result = confirm("選択したデータを削除しますか？");
      if (result == false) {
        return;
      }

      var self = this;
      axios
        .post(process.env.VUE_APP_ENGINEER_WORK_DELETE, {
          data: item
        })
        .then(function(response) {
          if (response.data["status"] == "success") {
            const index = self.list.indexOf(item);
            self.list.splice(index, 1);
          } else {
            alert("更新失敗・・！");
            console.log(response.data);
          }
          self.close();
        });
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 100);
    },

    newItem() {
      this.editedIndex = -1;
      this.editedItem = Object.assign(
        {},
        {
          id: -1,
          category: "",
          title: "",
          memo: "",
          source: "",
          img_count: 0,
          imageData1: "",
          imageData2: ""
        }
      );
    }
  },

  created: function() {
    axios.get(process.env.VUE_APP_ENGINEER_WORK_LIST).then(response => {
      console.log(response);
      // v-data-tableを使うときは配列に格納する
      const items = [];
      const values = Object.values(response.data);
      values.forEach(value => {
        const item = {
          id: value.id,
          category: value.category,
          title: value.title,
          memo: value.memo || "",
          source: value.source || "",
          img_count: value.img_count,
          imageData1: "",
          imageData2: ""
        };
        items.push(item);
      });
      this.list = items;
    });
  }
};
</script>

<style>

.custom_textarea textarea {
  line-height: 1.4 !important;
}

.v-content__wrap {
  overflow: scroll !important;
}

.content_header {
  position: sticky;
  top: 0;
  background: white;
  z-index: 1;
  box-shadow: 0 1px 6px #bbb;
}

.router-link-active {
  text-decoration: none;
}

.v-navigation-drawer__content
  .v-list-group
  .v-list-group__header
  .v-list-item__icon.v-list-group__header__append-icon {
  min-width: 35px;
}

.custom_table table {
  /* border: solid 1px #000000 !important; */
  border-collapse: collapse !important;
}
.custom_table th {
  background: #f4f4f4;
}
.custom_table th,
.custom_table td {
  border: 1px solid #ddd;
}

.v-data-table td,
.v-data-table th {
  padding: 0 8px;
}

.batch {
  display: block;
  font-size: 11px;
  color: #fff;
  border-radius: 6px;
  font-weight: bold;
  padding: 2px 0;
}
.batch.site {
  background-color: #2196f3;
}
.batch.appli {
  background-color: #4caf50;
}
.v-data-table .os_custom_table tr,
.v-data-table .os_custom_table td {
  padding: 3px;
  height: auto;
  text-align: left;
  border: none !important;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 200px;
}
.v-data-table .os_custom_table td img {
  vertical-align: middle;
}

.img_preview {
  width: 48%;
  display: inline-block;
  overflow: hidden;
  max-height: 130px;
  margin: 3px;
  max-width: 130px;
}

.img_preview img {
  object-fit: cover;
  width: 130px;
  height: 130px;
}

textarea {
  font-size: 14px !important;
  padding: 12px 8px !important;
}

/* .v-btn {
  justify-content: left !important;
} */
</style>